"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = exports.useSession = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const sessionBuilder_1 = require("../api/sessionBuilder");
const material_1 = require("@mui/material");
const SessionContext = (0, react_1.createContext)(undefined);
const useSession = () => {
    const ctx = (0, react_1.useContext)(SessionContext);
    if (!ctx)
        throw new Error("useSession must be used within a SessionProvider");
    return ctx;
};
exports.useSession = useSession;
const SessionProvider = ({ builderId, docType, children, }) => {
    const [session, setSession] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const isNewSession = builderId === "new";
    (0, react_1.useEffect)(() => {
        // If it's a new session, don't fetch - just create a placeholder
        if (isNewSession && docType) {
            setSession({
                id: "new",
                name: "", // Empty name for new sessions
                formId: "",
                appId: "",
                customerId: "",
                orgId: "",
                createdAt: new Date().toISOString(),
                html: "",
                isPublished: false,
                lastSavedSource: "",
                schema: null,
                updatedAt: new Date().toISOString(),
                docType: docType,
            });
            setLoading(false);
            setError(null);
            return;
        }
        // Otherwise fetch the existing session
        setLoading(true);
        setError(null);
        (0, sessionBuilder_1.fetchSessionByBuilderId)(builderId)
            .then((data) => {
            setSession(data);
            setLoading(false);
        })
            .catch((err) => {
            console.error("Error fetching session:", err);
            setError(err.message || "Failed to fetch session");
            setLoading(false);
        });
    }, [builderId, docType, isNewSession]);
    return ((0, jsx_runtime_1.jsx)(SessionContext.Provider, { value: { session, loading, error, setSession, isNewSession }, children: loading ? ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })) : error ? ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { color: "error", children: ["Error: ", error] }) })) : (children) }));
};
exports.SessionProvider = SessionProvider;
